/* eslint-disable rxjs-x/finnish */
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, Signal, inject, isSignal } from '@angular/core';
import { Observable, Subscription, isObservable } from 'rxjs';

@Pipe({
  name: 'unwrapAsyncValue',
  pure: false,
  standalone: true,
})
export class UnwrapAsyncValuePipe<T> implements PipeTransform, OnDestroy {
  readonly #cdr = inject(ChangeDetectorRef, { optional: true });

  #subscription?: Subscription;
  #lastObservable$?: Observable<T>;
  readonly #defaultResult = null;
  #lastEmittedResult: T | null = this.#defaultResult;

  public transform(value: T | Signal<T> | Observable<T>): T {
    if (isSignal(value)) {
      this.resetObservableCache();
      return value();
    }

    if (isObservable(value)) {
      this.subscribeToObservable(value);
      return this.#lastEmittedResult as T;
    }

    this.resetObservableCache();
    return value;
  }

  public ngOnDestroy(): void {
    this.resetObservableCache();
  }

  private subscribeToObservable(observable$: Observable<T>): void {
    if (this.#lastObservable$ === observable$) {
      return;
    }

    this.resetObservableCache();
    this.#lastObservable$ = observable$;
    this.#subscription = observable$.subscribe((result) => {
      this.#lastEmittedResult = result;
      if (this.#cdr) {
        this.#cdr.markForCheck();
      }
    });
  }

  private resetObservableCache(): void {
    this.#subscription?.unsubscribe();
    this.#lastObservable$ = undefined;
    this.#lastEmittedResult = this.#defaultResult;
  }
}
